/**
 * Editorial moment — the template's big centered statement, given to
 * scripture itself. The single serif (Lora) moment on the page.
 */
export function ScriptureEditorial() {
  return (
    <section className="bg-neutral-950 px-6 py-32 text-center md:px-12 md:py-44 lg:py-52">
      <p className="text-xs uppercase tracking-widest text-neutral-500">Galatians 5 : 22–23</p>
      <blockquote className="font-scripture mx-auto mt-10 max-w-4xl text-3xl leading-snug text-white md:text-5xl md:leading-tight">
        “But the fruit of the Spirit is love, joy, peace, patience, kindness, goodness,
        faithfulness, gentleness, and self-control.”
      </blockquote>
      <p className="mt-10 text-sm text-neutral-500">The whole app, in one verse.</p>
    </section>
  );
}
